import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ConfirmModal from './ConfirmModal';

const PAGES = [
  { id: 'raw-stock', label: 'สต็อก Raw Mat' },
  { id: 'restock', label: 'เติมสต็อก' },
  { id: 'bulk-stock', label: 'สต็อก Bulk' },
  { id: 'finished-stock', label: 'สต็อก Finished' },
  { id: 'adjust', label: 'ปรับสต็อก' },
  { id: 'formulas', label: 'สูตรน้ำหอม' },
  { id: 'production', label: 'สั่งผสม' },
  { id: 'bottling', label: 'บรรจุขวด' },
];

const DEFAULT_FORM = {
  username: '', password: '', name: '', tel: '',
  can_see_formula: false, can_see_raw_stock: true,
  can_see_bulk_stock: false, can_see_finished_stock: true, can_see_cost: false,
  permissions: PAGES.map(p => ({ page: p.id, can_view: false, can_create: false, can_edit: false, can_delete: false }))
};

export default function Users() {
  const [users, setUsers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState(DEFAULT_FORM);
  const [msg, setMsg] = useState({ text: '', ok: true });
  const [confirmToggle, setConfirmToggle] = useState(null);

  const load = () => axios.get('/api/users').then(r => setUsers(r.data));
  useEffect(() => { load(); }, []);

  const setF = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const setPerm = (page, action, val) => setForm(f => ({
    ...f,
    permissions: f.permissions.map(p => p.page === page ? { ...p, [action]: val } : p)
  }));

  const showMsg = (text, ok = true) => { setMsg({ text, ok }); setTimeout(() => setMsg({ text: '', ok: true }), 4000); };

  const handleEdit = async (u) => {
    const { data } = await axios.get(`/api/users/${u.id}`);
    const perms = PAGES.map(p => {
      const found = data.permissions?.find(x => x.page === p.id);
      return found || { page: p.id, can_view: false, can_create: false, can_edit: false, can_delete: false };
    });
    setForm({ ...data, password: '', permissions: perms });
    setEditId(u.id); setShowForm(true);
  };

  const handleSubmit = async () => {
    try {
      if (editId) await axios.put(`/api/users/${editId}`, form);
      else await axios.post('/api/users', form);
      showMsg(editId ? 'อัปเดต user สำเร็จ' : 'สร้าง user สำเร็จ');
      setShowForm(false); setEditId(null); setForm(DEFAULT_FORM); load();
    } catch (err) {
      showMsg(err.response?.data?.error || 'เกิดข้อผิดพลาด', false);
    }
  };

  const toggleActive = async (u) => {
    await axios.put(`/api/users/${u.id}`, { ...u, is_active: !u.is_active, permissions: [] });
    load(); setConfirmToggle(null);
  };

  return (
    <div>
      {confirmToggle && (
        <ConfirmModal
          title={confirmToggle.is_active ? 'ปิดใช้งาน User' : 'เปิดใช้งาน User'}
          body={`ต้องการ${confirmToggle.is_active ? 'ปิด' : 'เปิด'}ใช้งาน "${confirmToggle.username}"?`}
          onConfirm={() => toggleActive(confirmToggle)}
          onCancel={() => setConfirmToggle(null)}
          danger={confirmToggle.is_active}
        />
      )}

      {msg.text && (
        <div className={`alert ${msg.ok ? 'alert-success' : 'alert-danger'}`}>
          <i className={`ti ${msg.ok ? 'ti-check' : 'ti-alert-circle'}`}/>
          {msg.text}
        </div>
      )}

      {/* User list */}
      {!showForm && (
        <>
          <div className="sh">รายชื่อ User ทั้งหมด</div>
          <div className="glass-card">
            <table className="tbl">
              <thead>
                <tr><th>Username</th><th>ชื่อ</th><th>เบอร์</th><th>Role</th><th>สถานะ</th><th></th></tr>
              </thead>
              <tbody>
                {users.map(u => (
                  <tr key={u.id}>
                    <td style={{ fontWeight: 600, color: 'var(--text-primary)' }}>{u.username}</td>
                    <td>{u.name}</td>
                    <td>{u.tel || '—'}</td>
                    <td><span className={`badge ${u.role === 'superadmin' ? 'badge-purple' : 'badge-blue'}`}>{u.role}</span></td>
                    <td><span className={`badge ${u.is_active ? 'badge-ok' : 'badge-warn'}`}>{u.is_active ? 'ใช้งาน' : 'ปิด'}</span></td>
                    <td>
                      {u.role !== 'superadmin' && (
                        <div style={{ display: 'flex', gap: 6 }}>
                          <button className="btn-secondary" style={{ fontSize: 11, padding: '4px 10px' }} onClick={() => handleEdit(u)}>แก้ไข</button>
                          <button className="btn-secondary" style={{ fontSize: 11, padding: '4px 10px' }} onClick={() => setConfirmToggle(u)}>
                            {u.is_active ? 'ปิด' : 'เปิด'}
                          </button>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="btn-row">
              <button className="btn-primary" onClick={() => { setShowForm(true); setEditId(null); setForm(DEFAULT_FORM); }}>
                + สร้าง User ใหม่
              </button>
            </div>
          </div>
        </>
      )}

      {/* Form */}
      {showForm && (
        <>
          <div className="sh">{editId ? 'แก้ไข User' : 'สร้าง User ใหม่'}</div>
          <div className="glass-card">
            <div className="grid-2">
              <div className="form-group">
                <label className="fl">Username</label>
                <input className="fi" value={form.username} onChange={e => setF('username', e.target.value)} disabled={!!editId} placeholder="username"/>
              </div>
              <div className="form-group">
                <label className="fl">{editId ? 'Password ใหม่ (เว้นว่างถ้าไม่เปลี่ยน)' : 'Password'}</label>
                <input className="fi" type="password" value={form.password} onChange={e => setF('password', e.target.value)} placeholder="••••••••"/>
              </div>
            </div>
            <div className="grid-2">
              <div className="form-group">
                <label className="fl">ชื่อ-นามสกุล</label>
                <input className="fi" value={form.name} onChange={e => setF('name', e.target.value)} placeholder="ชื่อพนักงาน"/>
              </div>
              <div className="form-group">
                <label className="fl">เบอร์โทร</label>
                <input className="fi" value={form.tel} onChange={e => setF('tel', e.target.value)} placeholder="08x-xxx-xxxx"/>
              </div>
            </div>

            <div className="divider"/>
            <div className="sh" style={{ marginBottom: 8 }}>สิทธิ์การมองเห็นข้อมูล</div>

            {[
              { key: 'can_see_formula', label: 'เห็นสูตรน้ำหอม (BOM)', sub: 'รวมถึง % ส่วนผสมทุกกลิ่น' },
              { key: 'can_see_raw_stock', label: 'เห็นสต็อก Raw Material', sub: 'จำนวนและ avg cost' },
              { key: 'can_see_bulk_stock', label: 'เห็นสต็อก Bulk', sub: 'น้ำหอมผสมแล้ว รอบรรจุ' },
              { key: 'can_see_finished_stock', label: 'เห็นสต็อก Finished', sub: 'น้ำหอมบรรจุขวดแล้ว' },
              { key: 'can_see_cost', label: 'เห็นข้อมูลต้นทุน', sub: 'ราคา avg cost ต้นทุน/ขวด' },
            ].map(t => (
              <div key={t.key} className="toggle-wrap">
                <div className="toggle-info">
                  <div className="tl">{t.label}</div>
                  <div className="ts">{t.sub}</div>
                </div>
                <label className="toggle">
                  <input type="checkbox" checked={!!form[t.key]} onChange={e => setF(t.key, e.target.checked)}/>
                  <span className="toggle-slider"/>
                </label>
              </div>
            ))}

            <div className="divider"/>
            <div className="sh" style={{ marginBottom: 10 }}>สิทธิ์แต่ละเมนู</div>
            <div className="perm-grid">
              <div/>
              {['ดู','สร้าง','แก้ไข','ลบ'].map(h => <div key={h} className="perm-hd">{h}</div>)}
              {form.permissions.map(p => {
                const pi = PAGES.find(x => x.id === p.page);
                return (
                  <React.Fragment key={p.page}>
                    <div className="perm-page"><i className="ti ti-circle" style={{ fontSize: 10 }}/>{pi?.label}</div>
                    {[['can_view'],['can_create'],['can_edit'],['can_delete']].map(([k]) => (
                      <div key={k} className="perm-chk">
                        <input type="checkbox" checked={!!p[k]} onChange={e => setPerm(p.page, k, e.target.checked)}/>
                      </div>
                    ))}
                  </React.Fragment>
                );
              })}
            </div>

            <div className="btn-row">
              <button className="btn-secondary" onClick={() => { setShowForm(false); setEditId(null); }}>ยกเลิก</button>
              <button className="btn-primary" onClick={handleSubmit}>{editId ? 'บันทึก' : 'สร้าง User'}</button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
